// Source: app/scripts/controllers/document-templates-and-groups-controller.js
Auction.controller('DocumentTemplatesAndGroupsController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages) {


    $scope.modalAddOrEditDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_document_template_vocabulary_attachment.html',
      show: false
    });


    $scope.afterInit = function (crudScope) {

      crudScope.addAttachment = function(entity){
        console.log('tuka sum vo crud 2');
        $scope.entity = entity;
        $scope.modalAddOrEditDocument.show();
      };

      crudScope.downloadteAttachment = function (templateId) {
        if(templateId) {
          Downloader.download('/data/rest/portal_attachments/get_document_template_vocabulary_template/' + templateId);
        }
      };
    }

  }
]);
